import COPY from "../content/siteCopy.json";
import React, { useState } from "react";
import { CalendlyLink } from "../SiteHeader";

const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const fmt = (d) => d.toLocaleDateString("en-CA", { month: "short", day: "numeric" });
const fmtLong = (d) => d.toLocaleDateString("en-CA", { month: "long", year: "numeric" });

export function Timeline() {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const months = Array.from({ length: 12 }, (_, i) => new Date(today.getFullYear(), today.getMonth() + 1 + i, 1));
  const [pick, setPick] = useState(3);
  const keys = months[pick];
  const preBy = addDays(keys, -120);
  const offerBy = addDays(keys, -35);
  const late = preBy <= today;
  const holdEnd = addDays(late ? today : preBy, 120);
  const steps = [
    ["Get pre-approved", late ? "Today. This is not a drill." : `by ${fmt(preBy)}`, "Rate hold starts. You know your number."],
    ["House-hunt", `${fmt(late ? today : preBy)} → ${fmt(offerBy)}`, "Shop with a real ceiling. We stay on text for \"can we afford this one?\""],
    ["Offer accepted", `around ${fmt(offerBy)}`, "Five-day financing condition. Your file's already reviewed, so this is the easy part."],
    ["Keys", fmtLong(keys), holdEnd >= keys ? "Your 120-day hold covers you right through closing." : `Your hold runs to ${fmt(holdEnd)}—we renew it. Most buyers use two.`],
  ];
  return (
    <section className="tl" data-testid="preapproval-timeline">
      <div className="wrap">
        <div className="tl-head">
          <div><div className="eyebrow">Timing · work backwards from the keys</div><h2 className="display tl-h2">When should I <em>actually</em> get pre-approved?</h2></div>
          <p className="tl-lead">{COPY.solution.extras["pre-approval"][3].text}</p>
        </div>
        <div className="tl-months" role="tablist">
          {months.map((m, i) => <button type="button" key={i} role="tab" aria-selected={i === pick} className={`pq-chip${i === pick ? " on" : ""}`} onClick={() => setPick(i)} data-testid={`timeline-month-${i}`}>{m.toLocaleDateString("en-CA", { month: "short" })}{m.getMonth() === 0 ? ` ’${String(m.getFullYear()).slice(2)}` : ""}</button>)}
        </div>
        <ol className="tl-track" data-testid="timeline-track">
          {steps.map(([t, when, why], i) => (
            <li key={t} className={`tl-step${i === 0 && late ? " now" : ""}`} data-testid={`timeline-step-${i}`}>
              <span className="tl-dot" aria-hidden="true" />
              <b>{t}</b><strong>{when}</strong><small>{why}</small>
            </li>
          ))}
        </ol>
        <div className="tl-cta">
          <p>{late ? <>Moving in {fmtLong(keys)} means the 120-day hold math says <b>start now</b>—and honestly, that's fine. Pre-approval takes 1–3 business days.</> : <>Get pre-approved around <b>{fmt(preBy)}</b> and today's rate is held through to your keys. Rates drop in between? You get the lower one.</>}</p>
          <CalendlyLink className="btn" testId="timeline-cta">Let's Get This Going</CalendlyLink>
        </div>
      </div>
    </section>
  );
}
